<script>
import { VTab } from 'vuetify/lib'

export default {
  name: 'ETab',
  extends: VTab,
  props: {
    ripple: {
      type: Boolean,
      default: false,
    },
    activator: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        ...VTab.options.computed.classes.call(this),
        'e-tab': true,
        'e-tab--activator': this.activator,
      }
    },
  },
  methods: {
    click(e) {
      if (this.disabled) return
      // If user provides an
      // actual link, do not
      // prevent default
      if (this.href && this.href.indexOf('#') > -1) e.preventDefault()
      if (e.detail) this.$el.blur()
      this.$emit('click', e)
      this.to || this.toggle()
    },
  },

  render(h) {
    const { tag, data } = this.generateRouteLink()
    data.attrs = {
      ...data.attrs,
      'aria-selected': String(this.isActive),
      role: 'tab',
      tabindex: this.disabled ? -1 : 0,
    }
    data.on = {
      ...data.on,
      keydown: (e) => {
        if (e.keyCode === 13) this.click(e)
        this.$emit('keydown', e)
      },
    }
    return h(tag, data, this.$slots.default)
  },
}
</script>
